import React, { useEffect, useState } from "react";
import { AllTabType } from "src/types/GlobalInterfaces";
import DrawerTitle from "../Drawer/DrawerTitle";
import OrdersCard from "../Cards/OrdersCard";
import { toast } from "react-toastify";
import httpRequest from "src/helpers/httpRequest";
import { IPaginated } from "src/types/paginated";
import qs from "qs";
import InfiniteScroll from "react-infinite-scroll-component";
import SplashScreen from "../SplashScreen";
import moment from "moment";
import InfinteScrollWrapper from "../GlobalComponents/Widget/InfinteScrollWrapper";

interface IProps {
  onBack?: () => void;
  setActiveTab?: (tab: AllTabType) => void;
  onClose?: () => void;
}

const MyActivityCard: React.FC<{ activity: string; date: string; time: string }> = ({
  activity,
  date,
  time,
}) => {
  return (
    <div className="bg-white side-bar-padding box-design items-center flex gap-5">
      <div className="font-Poppins-Regular font-size-18px text-[#3B3B3B] flex-1">
        {activity}
      </div>
      <div className="font-size-16px font-Poppins-Regular text-[#3B3B3B]">
        <p>{date}</p>
        <p className="text-right leading-none font-Poppins-Regular font-size-14px opacity-85">{time}</p>
      </div>
    </div>
  );
};

interface IActivityLogs {
  log: string;
  createdAt: string;
}

const MyActivityScreen: React.FC<IProps> = ({
  onBack,
  setActiveTab,
  onClose,
}) => {
  const [activityLogs, setActivityLogs] = useState<IActivityLogs[]>([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 20,
  });
  const [isLoader, setIsLoader] = useState(false);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  });

  const fetchActivityLogs = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<{
      paginated: IPaginated;
      documents: IActivityLogs[];
    }>({ path: `/activitylog?${qs.stringify(queryParams)}` });
    if (res) {
      const { documents = [], paginated } = res;
      setActivityLogs((prev) => [...prev, ...documents]);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    fetchActivityLogs();
  }, [queryParams]);

  return (
    <>
      <DrawerTitle title="My Activity" backBtn onBack={onBack} />
      <div className="w-full h-full flex flex-col side-bar-padding-3 side-bar-gap overflow-y-auto">
        <InfinteScrollWrapper
          length={activityLogs.length}
          onLoadMore={(page: number) => {
            setQueryParams((prev) => ({ ...prev, page }));
          }}
          isLoading={isLoader}
          currentPage={queryParams.page}
          totalPages={paginated.totalPages}
          isLoadButton={true}
          noDataOptions={{
            text2: "No activity logs found",
          }}
        >
          {activityLogs.map((item, index) => (
            <MyActivityCard
              key={index}
              activity={item?.log}
              date={moment(item?.createdAt).format("DD-MM-YYYY")}
              time={moment(item?.createdAt).format("hh:mm A")}
            />
          ))}
        </InfinteScrollWrapper>
      </div>
    </>
  );
};

export default MyActivityScreen;
